import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type EmployerApplicant = {
  id: string;
  candidateId: string;
  jobId: string;
  jobTitle: string;
  name: string;
  title: string;
  location: string;
  experience: string;
  aiScore: number;
  skills: string[];
  availability: string;
  salary: string;
  summary: string;
  matchReasons: string[];
  appliedDate: string;
  email?: string;
  resumeUrl?: string;
  status: string;
};

export async function fetchEmployerApplicants(jobId?: string | number): Promise<EmployerApplicant[]> {
  if (!API_BASE_URL) {
    return [];
  }
  const url = jobId ? `${API_BASE_URL}/v1/employer/applicants?jobId=${jobId}` : `${API_BASE_URL}/v1/employer/applicants`;
  const response = await fetchWithAuth(url);
  if (!response.ok) {
    const text = await response.text().catch(() => 'request failed');
    throw new Error(`Applicants fetch failed (${response.status}): ${text}`);
  }
  const payload = await response.json();
  return (payload?.applicants as EmployerApplicant[]) ?? [];
}
